import { CheckCheckIcon } from 'lucide-react';

import { cn, formatRelativeTime } from '@/lib/utils';

import CustomerReaction from './CustomerReaction';

export default function TextMessage({
  emoji,
  customer_reaction,
  is_seen,
  is_seen_at,
  direction,
  text,
  contact_id,
  channel,
  _id: message_id,
  isLastSentMessage,
  is_reply,
}) {
  return (
    <div
      className={cn(
        'group text-left text-sm',
        // When inside a reply wrapper, skip the background and padding as the parent provides it
        is_reply
          ? ''
          : cn(
              'rounded-lg px-3 py-2',
              direction === 'sent'
                ? 'bg-muted'
                : 'bg-received text-primary-foreground'
            )
      )}
    >
      <p className=''>{text}</p>
      {is_seen && (
        <span className='absolute -bottom-2 right-0'>
          <CheckCheckIcon className='h-4 w-4 text-seen' />
        </span>
      )}
      {(emoji || customer_reaction) && (
        <span
          className={cn(
            'absolute -bottom-3 rounded-full border bg-primary-foreground px-[3px] text-xs text-primary',
            direction !== 'sent' ? 'left-2' : is_seen ? 'right-5' : 'right-2'
          )}
        >
          {emoji}
          {customer_reaction ? (emoji === '❤' ? null : '❤') : null}
          {emoji && customer_reaction ? '2' : null}
        </span>
      )}
      {is_seen_at && isLastSentMessage && direction === 'sent' && (
        <div
          className={cn(
            'absolute -bottom-6 truncate text-xs text-muted-foreground',
            direction === 'sent' ? 'right-0' : 'left-0'
          )}
        >
          Seen {formatRelativeTime(new Date(is_seen_at))}
        </div>
      )}
      {direction !== 'sent' && channel === 'instagram' && (
        <CustomerReaction
          direction={direction}
          customer_reaction={customer_reaction}
          message_id={message_id}
          contact_id={contact_id}
        />
      )}
    </div>
  );
}
